<template>

	<div class="list-content">
		<ul class="type-gallery row row-cols-1 row-cols-sm-2 row-cols-lg-4">

			<li class="col" v-for="item in importList" :id="'item-' + item.gid">
				<a href="javascript:;" @click="goGoodsOne(item.gid)">
					<div class="thumb-box" v-if="item.thumbnail !== null" :style="'background-image:url(' + APIs.SHOP_FILE_SHOW + item.thumbIdx + ');'"></div>
					<div class="thumb-box" v-else style="background-image:url(public/ssflex/assets/hws-images/icons8-color-64.png);"></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim">{{ item.cateVO.codeName }}</span>
							<span class="sec" v-if="item.isImport">추천상품</span>
						</div>
						<h3 class="tit">{{ item.title }}</h3>
						<p class="desc">
							{{ item.contentText }}
						</p>
						<ul class="info">
							<p class="price">{{ item.basePrice | currency }} <span class="unit">원</span></p>
							<!--							<li class="auth"><span class="blind">작성자</span>{{ item.writerDec }}</li>-->
						</ul>
					</div>
				</a>
			</li>

			<li class="col" v-for="item in goodsList" :id="'item-' + item.gid">
				<a href="javascript:;" @click="goGoodsOne(item.gid)">
					<div class="thumb-box" v-if="item.thumbnail !== null" :style="'background-image:url(' + APIs.SHOP_FILE_SHOW + item.thumbIdx + ');'"></div>
					<div class="thumb-box" v-else style="background-image:url(public/ssflex/assets/hws-images/icons8-color-64.png);"></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim">{{ item.cateVO.codeName }}</span>
							<span class="sec" v-if="item.isImport">추천상품</span>
						</div>
						<h3 class="tit">{{ item.title }}</h3>
						<p class="desc">
							{{ item.contentText }}
						</p>
						<ul class="info">
							<!-- 하드코딩 -->
							<p class="price">
								<template v-if="item.makerCode === '100103' && item.basePrice === 0 && getOneYearOptionPrice(item) !== null">
									{{ getOneYearOptionPrice(item) | currency }} <span class="unit">원</span> / 1년
								</template>
								<template v-else>{{ item.basePrice | currency }} <span class="unit">원</span></template>
							</p>
							<!--							<li class="auth"><span class="blind">작성자</span>{{ item.writerDec }}</li>-->
						</ul>
					</div>
				</a>
			</li>

		</ul>
	</div>

</template>

<script>
export default {
	name: "goodsList",
	props: {
		importList: Array,
		goodsList: Array,
	},
	data() {

		return {}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		goGoodsOne(_idx) {
			location.href = "/app/shop/goods/" + _idx;
		},

		/** makerCode 100103, basePrice 0일 때 "1년" 옵션의 optionPrice 반환 (없으면 null) 하드코딩 */
		getOneYearOptionPrice(item) {
			if (!item.licenseOptionDetails || !item.licenseOptionDetails.length) return null;
			const oneYear = item.licenseOptionDetails.find(d => d.optionName === "1년");
			if (!oneYear || oneYear.optionPrice == null || oneYear.optionPrice === "") return null;
			const price = parseInt(oneYear.optionPrice, 10);
			return isNaN(price) ? null : price;
		}

	},
	watch: {}
}
</script>

<style scoped>

</style>
